module.exports = __webpack_public_path__ + "img/专用集成电源 (1).8975ccea.jpg";